/**
 * A smaller copy of a Shopify CDN image for a small slot (D5). The app's image URLs carry their size in the file name
 * (…/DSC08636_600x.jpg?v=…); Shopify serves any size by changing that part. Only the sizes the app itself asks Shopify for
 * are rewritten (200, 500, 600, 800), so a photo whose own name ends in something like _2x is left alone; anything else
 * comes back unchanged, and the tiles fall back to the original URL if a smaller copy ever fails to load.
 * Display only: the QA photo checks read the image sizes from the server, never from these URLs.
 */
export function thumb(url: string, width: number): string {
  return url.replace(/_(200|500|600|800)x\.(jpe?g|png|webp|gif)(\?|$)/i, (_m, _w, ext, q) => `_${width}x.${ext}${q}`)
}
